var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "candado") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login",
    transform: "translate(-570.000000, -390.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(472.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "candado",
    transform: "translate(98.000000, 277.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8125,6.75 L11.2499996,6.75 L11.2499996,4.5 C11.2499996,2.01825 9.23175036,0 6.75,0 C4.26825004,0 2.25000004,2.01825 2.25000004,4.5 L2.25000004,6.75 L1.6875,6.75 C0.757500161,6.75 0,7.50674988 0,8.4375 L0,16.3125 C0,17.2432501 0.757500161,18 1.6875,18 L11.8125,18 C12.7425001,18 13.5,17.2432501 13.5,16.3125 L13.5,8.4375 C13.5,7.50674988 12.7425001,6.75 11.8125,6.75 L11.8125,6.75 Z M3.75,4.5 C3.75,2.84550008 5.09549976,1.5 6.75,1.5 C8.40450024,1.5 9.75,2.84550024 9.75,4.5 L9.75,6.75 L3.75,6.75 L3.75,4.5 Z M7.5,12.5415001 L7.5,14.25 C7.5,14.6640003 7.1647503,15 6.75,15 C6.3352497,15 6,14.6640003 6,14.25 L6,12.5415001 C5.55374979,12.2812501 5.25,11.8027505 5.25,11.25 C5.25,10.4227503 5.92275024,9.75 6.75,9.75 C7.5772497,9.75 8.25,10.4227503 8.25,11.25 C8.25,11.8027497 7.94625021,12.2812501 7.5,12.5415001 L7.5,12.5415001 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e46504d2ceed8fd6924fb098d5e1e539.svg";
export { ForwardRef as ReactComponent };